import React, { Fragment } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormControl, Label, Input, Button, FormErrorText, Heading } from '@happyfoxinc/react-ui'
import toast from 'react-hot-toast'

import confluenceAuthFormValidationSchema from './confluence-auth-form-validation-schema'
import { useAppDetailContext } from '../../AppDetailContext'
import { useInstallMutation } from './confluence.service'
import parseErrorMessage from 'Utils/error-message-parser'

const ConfluenceAuthForm = (props) => {
  const { onCancel, app } = props
  const { title } = useAppDetailContext()
  const [install, installResult] = useInstallMutation()

  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors, isDirty }
  } = useForm({
    defaultValues: {
      accountUrl: app.account_url,
      installCode: app.installation_code
    },
    resolver: yupResolver(confluenceAuthFormValidationSchema)
  })

  const handleConnect = async (data) => {
    const payload = {
      account_url: data.accountUrl,
      installation_code: data.installCode
    }

    try {
      const promise = install(payload).unwrap()

      toast.promise(promise, {
        loading: `Connecting to ${title}`,
        success: `Successfully connected to ${title}`,
        error: parseErrorMessage(`Unable to connect to ${title}. Try again...`)
      })
      await promise
      onCancel()
    } catch {}
  }

  const disableSubmitButton = isSubmitting || !isDirty || installResult.isLoading

  return (
    <Fragment>
      <Heading level={2}>Connect to {title}</Heading>
      <form onSubmit={handleSubmit(handleConnect)}>
        <FormControl isInvalid={errors.accountUrl}>
          <Label>Account URL</Label>
          <Input {...register('accountUrl')} />
          {errors.accountUrl && <FormErrorText>{errors.accountUrl.message}</FormErrorText>}
        </FormControl>
        <FormControl isInvalid={errors.apiKey}>
          <Label>Installation Code</Label>
          <Input {...register('installCode')} />
          {errors.installCode && <FormErrorText>{errors.installCode.message}</FormErrorText>}
        </FormControl>
        <Button variant='primary' type='submit' disabled={disableSubmitButton}>
          Connect
        </Button>
        <Button variant='link-muted' onClick={onCancel}>
          Cancel
        </Button>
      </form>
    </Fragment>
  )
}

export default ConfluenceAuthForm
